// libraries
import React from 'react'

// components
import Image, { ImageProps } from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
interface ImageWithCaptionProps extends Omit<ImageProps, 'className'> {
    caption?: string
    className?: string
}

export default function ImageWithCaption({
    caption,
    className,
    ...imageProps
}: ImageWithCaptionProps) {
    return (
        <div className={className}>

            <div className='shape-mask'>
                <Image
                    {...imageProps as ImageProps}
                    style={{ width: '100%' }}
                />
            </div>

            {isNonWhitespaceString(caption) && (
                <p className='image--caption text-smaller'>
                    {caption}
                </p>
            )}

        </div>
    )
}